<template>
  <div class="container">
    
 <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4">
    <div  class="rounded-md shadow overflow-hidden max-w-4xl">              
       <div v-for="(stream,index) in streams" :key="index" class="rounded bg-inexgrayo overflow-hidden shadow-lg">
          <accordion  class="mb-4 mr-4 ml-4 mt-4">
          <template v-slot:title>
            <span class="font-semibold text-xl text-white">{{ stream['name'] }}</span>
          </template>
          <template v-slot:content>
              <br><br>
            <b class="text-white">Fecha:</b><p class="text-white">{{ stream['createdAt'] }}</p>
            <br><br>
            <button  style="color: white;" class="px-8 py-3 btn-indigoOrange" @click="showModal(stream['url'])"">
            <span>Ver</span>
            <span class="hidden md:inline">Stream</span>
            </button>
          </template>
        </accordion> 
      </div>
      </div>
      <div  class="rounded-md shadow overflow-hidden max-w-4xl">
        <iframe class="bg-black" :src="url" height="100%" width="100%"/>
      </div>      
      
    </div>
</div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Accordion from '@/Shared/Accordion';
import Modal from '@/Shared/Modal.vue';



export default {
  metaInfo: { title: 'Streams' },
  components: {
    Accordion,
    Modal,
  },
  layout: Layout,
  props: {
    streams: Array,
  },
  mounted(){
  },
data () {
      return {
      isModalVisible: false,
      url: "",
      }
    },
    methods:{
       showModal(url1) {
        this.isModalVisible = true;
        this.url = url1;
      },
      closeModal() {
        this.isModalVisible = false;
      },
    }
  }
</script>
<style>
  .small {
    max-width: 300px;
    margin:  10px auto;
  }
</style>